module.exports = __webpack_public_path__ + "img/B66D59_F0C9B2_E5B49C_DAA084-256px.d2fc505f.png";